<template>
    <AppHeader />
    <div id="pagebody">
        <!-- <MyTabbar /> -->
        <router-view :key="$route.path" />
    </div>
    <AppFooter />
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
// import MyTabbar from "./components/Tabbar.vue";

export default {
    name: "App",
    components: {
        AppHeader,
        AppFooter,
        // MyTabbar,
    },
};
</script>

<style>
@import "../../assets/styles/base_commentout_image.css";
#pagebody {
    width: 980px;
    margin: 30px auto 70px;
}
</style>
